import { VideoCard } from "./VideoCard";
import type { Video } from "@/types/video";

interface VideoGridProps {
  videos: Video[];
  onVideoClick?: (video: Video) => void;
  showCategoryBadges?: boolean;
}

export function VideoGrid({ videos, onVideoClick, showCategoryBadges = true }: VideoGridProps) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-5">
      {videos.map((video) => (
        <VideoCard
          key={video.id}
          video={video}
          onClick={() => onVideoClick?.(video)}
          showCategoryBadges={showCategoryBadges}
        />
      ))}
    </div>
  );
}
